import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import "./assets/styles/styles.css";
import "react-toastify/dist/ReactToastify.css";
import "material-icons/iconfont/material-icons.css";
import "./assets/fonts/fira-sans/stylesheet.css";

import "./config/firebase";

import LoginRouteLayout from "./components/templates/layouts/LoginRouteLayout";
import DashboardLayoutRoute from "./components/templates/layouts/DashbordRouteLayout/DashbordLayoutRoute";
import Loader from "./components/atoms/Loader";
import { isDevEnv } from "./utils/generalUtils";
import PageNotFound from "./components/pages/PageNotFound";

const OverviewTemplateTableDataPage = lazy(
  () => import("./components/pages/OverviewTemplateTableData")
);
const Home = lazy(() => import("./components/pages/Home"));
const MultiTemplateBuilderPage = lazy(
  () =>
    import(
      "./components/pages/MultiTemplateBuilderPage/MultiTemplateBuilderPage"
    )
);
const Hwr = lazy(() => import("./components/pages/Hwr"));
const ReportingServices = lazy(
  () => import("./components/pages/ReportingServices")
);
const Administration = lazy(() => import("./components/pages/Administration"));
const TableRowDetailPage = lazy(
  () => import("./components/pages/TableRowDetail")
);
const TableRowEditPage = lazy(() => import("./components/pages/TableRowEdit"));
const TableRowCreatePage = lazy(
  () => import("./components/pages/TableRowCreate")
);
const ResetPassword = lazy(() => import("./components/pages/ResetPassword"));
const Login = lazy(() => import("./components/pages/Login"));
const MountableDevUtils = lazy(() => import("./utils/MountableDevUtils"));
const Settings = lazy(() => import("./components/pages/Settings"));
const Registration = lazy(() => import("./components/pages/Registration"));
const TableRowMultiDetailPage = lazy(
  () => import("./components/pages/TableRowMultiDetail")
);
const TableRowMultiEditPage = lazy(
  () => import("./components/pages/TableRowMultiEdit")
);
const HegMappingPage = lazy(() => import("./components/pages/HegMapping"));
const MicrosoftLogin = lazy(() => import("./components/pages/MicrosoftLogin"));

const App = () => (
  <Suspense fallback={<Loader />}>
    <Switch>
      <Route path="/test">
        <div>route test</div>
      </Route>
      <LoginRouteLayout path="/login" component={Login} />
      <LoginRouteLayout path="/microsoftoauth2" component={MicrosoftLogin} />

      <LoginRouteLayout path="/registration" component={Registration} />
      <LoginRouteLayout path="/reset-password" component={ResetPassword} />

      <DashboardLayoutRoute exact path="/" component={Home} />
      <DashboardLayoutRoute path="/hwr" component={Hwr} />
      <DashboardLayoutRoute
        path="/reporting-services/:templateId"
        component={ReportingServices}
      />

      {/* ADMINISTRATION */}
      <DashboardLayoutRoute path="/administration" component={Administration} />
      <DashboardLayoutRoute
        path="/template-builder-multi/:templateId?"
        render={({ match }) => (
          <MultiTemplateBuilderPage templateId={match.params.templateId} />
        )}
      />
      {/* DATA */}
      <DashboardLayoutRoute
        path="/overview/:templateId"
        component={OverviewTemplateTableDataPage}
      />
      <DashboardLayoutRoute
        path="/detail/:templateId/:rowKeyValue"
        component={TableRowDetailPage}
      />
      <DashboardLayoutRoute
        path="/edit/:templateId/:rowKeyValue"
        component={TableRowEditPage}
      />
      <DashboardLayoutRoute
        path="/create/:templateId"
        component={TableRowCreatePage}
      />
      <DashboardLayoutRoute
        path="/multi-detail/:templateId/:rowKeyValue"
        component={TableRowMultiDetailPage}
      />
      <DashboardLayoutRoute
        path="/multi-edit/:templateId/:rowKeyValue"
        component={TableRowMultiEditPage}
      />
      <DashboardLayoutRoute
        path="/heg-mapping/:datasourceId"
        component={HegMappingPage}
      />
      <DashboardLayoutRoute path="/settings" component={Settings} />

      <Route component={PageNotFound} />
    </Switch>

    {isDevEnv && <MountableDevUtils />}
  </Suspense>
);

export default App;
